import React, { Component }            from 'react';
import { EmployeeOnboardingConstants } from './environment';
import { isInRoleFromToken }           from '../../../utils/authService';

class EmployeeOnboardingBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(EmployeeOnboardingConstants.AdminRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            {/*<li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.AdminHashPrefix + '/home'} className="anchor c-breadcrumbs__anchor" >
                Home
              </a>
            </li>*/}
            <li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.AdminHashPrefix + '/requests'} className="anchor c-breadcrumbs__anchor" >
                Requests
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.AdminHashPrefix + '/responses'} className="anchor c-breadcrumbs__anchor" >
                Responses
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.AdminHashPrefix + '/add'} className="anchor c-breadcrumbs__anchor" >
                Add
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.UserHashPrefix + '/door'} className="anchor c-breadcrumbs__anchor" >
                Door
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (isInRoleFromToken(EmployeeOnboardingConstants.DoorRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={EmployeeOnboardingConstants.UserHashPrefix + '/door'} className="anchor c-breadcrumbs__anchor" >
                Door
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (EmployeeOnboardingConstants.UserRole === "*" || isInRoleFromToken(EmployeeOnboardingConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default EmployeeOnboardingBreadcrumb;